import { render, staticRenderFns } from "./coaterStyle.vue?vue&type=template&id=39ef580c&"
import script from "./coaterStyle.vue?vue&type=script&lang=js&"
export * from "./coaterStyle.vue?vue&type=script&lang=js&"
import style0 from "./coaterStyle.vue?vue&type=style&index=0&id=39ef580c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports